function isPWA () {
    // Check if display-mode is standalone, which is a common indicator of a PWA
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  
    // Specific to iOS - check if the app was launched from the home screen
    const launchedFromHomeScreen = window.navigator.standalone || false;
  
    // Log these values for debugging or additional logic if needed
    console.log(`isStandalone: ${isStandalone}, launchedFromHomeScreen: ${launchedFromHomeScreen}`);
  
    // Consider the app a PWA if it is standalone or was launched from the home screen
    return isStandalone || launchedFromHomeScreen;
}

export default {
    isPWA
}